import { FC } from 'react';
import { Container } from 'react-bootstrap';
import { Button } from '../../atoms';
import { useNavigate, useParams } from 'react-router-dom';
import cn from 'classnames';
import styles from './LandscapeAboutCommittedBuyersTemplate.module.css';
import { LandscapeAboutCommittedBuyersOrganism } from '../../organisms';
import BaseTemplate from '../BaseTemplate';
import LandscapeBaseEditTemplate from '../../../templates/LandscapeBaseEditTemplate';
import LandscapeAboutBaseEditTemplate from '../../../templates/LandscapeAboutBaseEditTemplate';
import { LandscapeBuyerRelationType } from '../../../store/landscapeAPI/landscape/landscape-buyer-relation-type';

interface TableItem {
  id: string;
  logo: string;
  name: string;
  url: string;
  relationType: LandscapeBuyerRelationType;
}

interface LandscapeAboutCommittedBuyersTemplateProps {
  organizations: TableItem[];
  handleDelete: (id: string) => void;
}

const LandscapeAboutCommittedBuyersTemplate: FC<
  LandscapeAboutCommittedBuyersTemplateProps
> = ({ organizations, handleDelete }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  return (
    <>
      <BaseTemplate>
        <Container>
          <LandscapeBaseEditTemplate>
            <LandscapeAboutBaseEditTemplate>
              <div className={cn(styles.landscapeAboutContactPersonsWrapper)}>
                <div className={cn(styles.button)}>
                  <Button
                    variant="dark"
                    onClick={() =>
                      navigate(
                        `/landscapes/edit/${id}/about/committed-buyers/add`
                      )
                    }
                  >
                    Add Partner
                  </Button>
                </div>
                <div className={cn(styles.tableWrapper)}>
                  <LandscapeAboutCommittedBuyersOrganism
                    data={organizations}
                    handleDelete={handleDelete}
                  />
                </div>
              </div>
            </LandscapeAboutBaseEditTemplate>
          </LandscapeBaseEditTemplate>
        </Container>
      </BaseTemplate>
    </>
  );
};

export default LandscapeAboutCommittedBuyersTemplate;
